import { http } from '../index'

// 友情链接相关接口类型定义
export interface Link {
  id: number
  title: string
  url: string
  logo?: string
  description?: string
  sort_order: number
  views: number
  status: string
  creator?: {
    id: number
    name: string
  }
  created_at: string
  updated_at: string
}

export interface LinkListParams {
  page?: number
  per_page?: number
  keyword?: string
  status?: string
  sort_field?: string
  sort_order?: string
}

export interface LinkCreateData {
  title: string
  url: string
  logo?: string
  description?: string
  sort_order?: number
  status: string
}

export interface LinkUpdateData extends Partial<LinkCreateData> {}

// 友情链接API
export const linkApi = {
  // 获取友情链接列表
  list: (params: LinkListParams = {}) => {
    return http.get('link/links', { params })
  },

  // 创建友情链接
  create: (data: LinkCreateData) => {
    return http.post('link/links', data)
  },

  // 获取友情链接详情
  detail: (id: number) => {
    return http.get(`link/links/${id}`)
  },

  // 更新友情链接
  update: (id: number, data: LinkUpdateData) => {
    return http.put(`link/links/${id}`, data)
  },

  // 删除友情链接
  delete: (id: number) => {
    return http.delete(`link/links/${id}`)
  },

  // 更新友情链接状态
  updateStatus: (id: number, status: string) => {
    return http.patch(`link/links/${id}/status`, { status })
  },

  // 批量删除
  batchDelete: (ids: number[]) => {
    return http.post('link/links/batch-delete', { ids })
  },

  // 批量更新状态
  batchUpdateStatus: (ids: number[], status: string) => {
    return http.post('link/links/batch-update-status', { ids, status })
  },

  // 获取启用的链接
  activeLinks: () => {
    return http.get('link/links/active')
  },

  // 获取统计数据
  statistics: () => {
    return http.get('link/links/statistics')
  },
}

export default linkApi
